import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Card, StatusBadge, Modal, Field, Select, TextInput, TextArea } from "./adminShared";
import { formatDate, formatTimeIST, formatINR } from "@/lib/format";

export default function Bookings() {
  const [items, setItems] = useState(null);
  const [sel, setSel] = useState(null);

  const load = () => api.get("/admin/bookings").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.patch(`/admin/bookings/${sel.bookingReference}`, { status: sel.status, internalNotes: sel.internalNotes, meetingLink: sel.meetingLink });
      toast.success("Saved"); setSel(null); load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div>
      <h1 className="text-3xl text-earth mb-6" style={{ fontWeight: 600 }}>Bookings</h1>
      {!items ? <p className="text-earth/50">Loading…</p> : items.length === 0 ? <p className="text-earth/50">No bookings yet.</p> : (
        <Card className="overflow-hidden">
          <div className="divide-y divide-hairline">
            {items.map((b) => (
              <button key={b.bookingReference} onClick={() => setSel({ ...b })} className="w-full text-left p-4 hover:bg-parchment transition-colors flex justify-between items-start gap-4" data-testid={`booking-${b.bookingReference}`}>
                <div>
                  <p className="font-semibold text-earth">{b.client?.fullName} <span className="text-earth/40 font-normal">· {b.serviceSnapshot?.title}</span></p>
                  <p className="text-sm text-earth/60">{formatDate(b.scheduledStart)}, {formatTimeIST(b.scheduledStart)} IST</p>
                  <p className="text-xs text-earth/40 mt-1">{b.bookingReference} · {b.client?.email}</p>
                </div>
                <StatusBadge status={b.status} />
              </button>
            ))}
          </div>
        </Card>
      )}

      {sel && (
        <Modal title={`Booking ${sel.bookingReference}`} onClose={() => setSel(null)}>
          <div className="space-y-1 text-sm text-earth/80">
            <p><strong>{sel.client?.fullName}</strong> · {sel.client?.email} · {sel.client?.phone}</p>
            <p>{sel.serviceSnapshot?.title} · {formatINR(sel.serviceSnapshot?.price)}</p>
            <p>{formatDate(sel.scheduledStart)}, {formatTimeIST(sel.scheduledStart)} IST</p>
            {sel.concernSummary && <p className="pt-2 bg-parchment p-3 rounded-md border hairline whitespace-pre-wrap"><span className="text-xs uppercase text-earth/50">Concern (confidential)</span><br />{sel.concernSummary}</p>}
          </div>
          <Field label="Status"><Select value={sel.status} onChange={(e) => setSel({ ...sel, status: e.target.value })} data-testid="booking-status">
            <option value="pending_request">Pending request</option><option value="confirmed">Confirmed</option><option value="completed">Completed</option><option value="cancelled">Cancelled</option><option value="no_show">No-show</option>
          </Select></Field>
          <Field label="Meeting link (online sessions)"><TextInput value={sel.meetingLink || ""} onChange={(e) => setSel({ ...sel, meetingLink: e.target.value })} placeholder="https://zoom.us/…" /></Field>
          <Field label="Private notes"><TextArea rows={3} value={sel.internalNotes || ""} onChange={(e) => setSel({ ...sel, internalNotes: e.target.value })} /></Field>
          <button onClick={save} className="btn-gold w-full" data-testid="booking-save">Save</button>
        </Modal>
      )}
    </div>
  );
}
